import { render, staticRenderFns } from "./_filter_by_link_sharing_options.vue?vue&type=template&id=499980f8&scoped=true&"
var script = {}
import style0 from "./_filter_by_link_sharing_options.vue?vue&type=style&index=0&id=499980f8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499980f8",
  null
  
)

export default component.exports